import { useEffect, useMemo, useState } from 'react';
import ActionsSettingsForm from './ActionsSettingsForm';
import { ActionTypes } from '../utils';
import { isEmpty } from 'lodash';

const ActionsSettingsFormContainer = (props) => {
  const { settings, submitRef, onSubmit, translations } = props || {},
    { Errors } = translations || {};

  const [settingsState, setSettingsState] = useState([]);

  const adaptedSettings = useMemo(
    () => settings?.map((s, index) => ({ ...s, index, errors: {} })),
    [settings]
  );
  const actions = useMemo(() => Object.values(ActionTypes), []);
  const orderNumbers = useMemo(
    () =>
      actions?.map((s, index) => {
        const idAndOrderNum = ++index;
        return { id: idAndOrderNum, orderNum: idAndOrderNum };
      }),
    [actions]
  );

  useEffect(() => {
    setSettingsState(adaptedSettings);
  }, [adaptedSettings]);

  const onChangeHandler = (event, index) => {
    const { name, value } = event?.target || {};
    changeState(name, value, index);
  };

  const onCheckBoxChangeHandler = (event, index) => {
    const { name, checked } = event?.target || {};
    setSettingsState((prevState) =>
      prevState?.map((s) => {
        const isDisabled = !!checked;
        if (isDisabled && s.errors['orderNum']) {
          delete s.errors['orderNum'];
        }
        return s.index === index
          ? { ...s, [name]: checked, orderNum: isDisabled ? 0 : s.orderNum }
          : s;
      })
    );
  };

  const onComboBoxChangeHandler = (name, value, index) => {
    changeState(name, value, index);
  };

  function changeState(name, value, index) {
    setSettingsState((prevState) =>
      prevState?.map((s) => {
        return s.index === index ? { ...s, [name]: value } : s;
      })
    );
  }

  function removeErrors(name, index) {
    setSettingsState((prevState) =>
      prevState?.map((s) => {
        if (s.index === index) {
          delete s?.errors?.[name];
        }
        return s;
      })
    );
  }

  const clientValidationHandler = () => {
    if (settingsState?.some((s) => !isEmpty(s.errors))) return true;
    let hasErr = false;
    setSettingsState((prevState) =>
      prevState?.map((s) => {
        const errorsProps = Object.keys(Errors);
        let objectErrors = {};
        errorsProps?.forEach((err) => {
          if ((err === 'orderNum' && !!s.hide) || s.type === ActionTypes.CREATE)
            return;
          if (!s[err]) {
            objectErrors[err] = Errors[err];
            hasErr = true;
          }
        });
        return { ...s, errors: objectErrors };
      })
    );
    return hasErr;
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    if (clientValidationHandler()) return;
    onSubmit(settingsState);
  };

  return (
    <ActionsSettingsForm
      submitRef={submitRef}
      translations={translations}
      settingsState={settingsState}
      orderNumbers={orderNumbers}
      onSubmit={onSubmitHandler}
      onChange={onChangeHandler}
      onCheckBoxChange={onCheckBoxChangeHandler}
      onComboBoxChange={onComboBoxChangeHandler}
      removeErrors={removeErrors}
    />
  );
};

export default ActionsSettingsFormContainer;
